export const hasErrorsOnCurrentFields = (errors, validationFieldNames) =>
  !Object.keys(errors).some(errorFieldName => validationFieldNames.includes(errorFieldName));
